import React from "react"
import { TicketPromo } from "../../components"

const Ticket = () =>{
    return(
        <TicketPromo/>
    )
}

export default Ticket